// Integration glue for the CRM's site-wide marketing-attribution script
// (lv-attribution.js). The script loads on every page and stores nothing until
// init() is called — so we drive init()/clear() from our consent state. See
// docs/OFFICEPORTAL-ATTRIBUTION-INTEGRATION.md (CRM contract).

export const LV_ATTRIBUTION_SRC = 'https://crmapi.awarious.com/forms/lv-attribution.js';

/** Registrable domain so first-touch cookies span www → app subdomains. */
export const LV_COOKIE_DOMAIN = '.officeportal.io';

/** The subset of window.LVAttribution we call. */
export interface LVAttributionApi {
  init: (options?: { cookieDomain?: string; entry?: Record<string, string> }) => void;
  clear: () => void;
}

/**
 * Apply our marketing-consent state to lv-attribution.js:
 *  - granted  → init() (flushes the entry snapshot to first-party cookies)
 *  - denied   → clear() (erases the attribution cookies)
 *  - unknown  → no-op (no consent decision yet)
 * No-op when the script isn't loaded yet. init()/clear() are idempotent on the
 * CRM side, so repeated calls are safe. Returns the action taken (for tests).
 */
export function applyConsentToLVAttribution(
  lv: LVAttributionApi | undefined,
  marketing: boolean | undefined,
  cookieDomain: string = LV_COOKIE_DOMAIN,
): 'init' | 'clear' | 'noop' {
  if (!lv || marketing === undefined) return 'noop';
  if (marketing) {
    lv.init({ cookieDomain });
    return 'init';
  }
  lv.clear();
  return 'clear';
}
